import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBackgroundTaskStore = defineStore('backgroundTask', () => {
  // taskId, полученный из response.data.backgroundTaskId после сохранения формы
  const taskId = ref<string | null>(null)

  const setTaskId = (id: string | null) => {
    taskId.value = id
  }

  const clearTaskId = () => {
    taskId.value = null
  }

  return {
    taskId,
    setTaskId,
    clearTaskId
  }
})
